export interface ICmsBannerContainerProps {
  pwaCallToActionLink?: string;
  url: ICmsBannerUrl;
  onClick?: () => void;
}

export interface ICmsBannerProps {
  source: string;
  link?: string;
  onClick?: () => void;
}

export interface ICmsBannerData {
  banners: ICmsBanner[];
}

export interface ICmsBanner {
  pwaCallToActionLink?: string;
  url: string;
  tabletUrl: string;
  desktopUrl: string;
}

export interface ICmsBannerUrl {
  desktopUrl: string;
  tabletUrl: string;
  url: string;
}

export enum CmsBannerType {
  unregisteredUser = 'unregistered_user',
  userWithoutVouchers = 'user_without_welcome_discounts_vouchers',
  arlBanner = 'arl_banner_pwa',
  kidsBanner = 'kids_banner_home',
  kidsBannerUnreg = 'kids_banner_home_unreg',
}
